export default "__VITE_ASSET__DFC91h9A__"